import { Event } from "../models/Event";

export const mockEvents: Event[] = [
  {
    id: "e1",
    type: "Match",
    date: "2025-04-01",
    time: "10:30",
    location: "Reading FC Academy",
    postcode: "RG2 0FL",
    opponent: "U12 Eagles",
    notes: "Cup quarter-final",
    homeScore: 3,
    awayScore: 1,
    difficulty: "Medium",
    playerStats: [
      { player: "James", goals: 1 },
      { player: "Oliver", goals: 2 }
    ],
    manOfTheMatch: "Oliver",
    eventName: "Test event"
  },
  {
    id: "e2",
    type: "Training",
    date: "2025-04-02",
    time: "18:00",
    endTime: "19:30",
    location: "Local Sports Centre",
    postcode: "RG6 1LF",
    notes: "Focus on passing drills",
    eventName: "Test event"
  },
  {
    id: "e3",
    type: "Match",
    date: "2025-04-05",
    time: "11:00",
    location: "Highfield Park",
    postcode: "RG4 6XH",
    opponent: "Tigers U12",
    notes: "League match",
    eventName: "Test event",
    homeScore: 1,
    awayScore: 1,
    difficulty: "Hard",
    playerStats: [
      { player: "Lucas", goals: 1 }
    ],
    manOfTheMatch: "Lucas"
  }
];